import { AdContainer, AdContainerSize, Flex } from '@/common/components';
import { createComponent, If, IntrinsicProps } from '@/common/util/templateHelpers';
import Yolla, { YollaType, YollaSubType } from '@/components/Yolla';
import { useAuthStore } from '@/stores/auth';
import { useBreakpoint } from '@/hooks/useBreakpoint';

import style from './index.module.scss';

const classStates = [
  'fullScreen',
  'fixedFullScreen',
];

interface AdSandwichProps extends IntrinsicProps {
  fullScreen?: boolean
  fixedFullScreen?: boolean
}

export default createComponent<AdSandwichProps>('AdSandwich', 
  { style, classStates }, 
  function AdSandwich ({ className }, props) {
    const [ authState ] = useAuthStore();
    const breakpoint = useBreakpoint();
    const shouldShowAd = authState.ready && !authState.user?.hasGamePass;

    return (
      <Flex alignCenter className={className}>
        {
          If(shouldShowAd, () => (
            <Flex alignCenter justifyCenter className='AdSandwich__Ad AdSandwich__Ad--column'>
              <Yolla type={YollaType.DESKTOP_MEDRECT} subType={YollaSubType.DESKTOP_HALFPAGE} num={1} />
            </Flex>
          )).EndIf()
        }
        <Flex tall directionColumn fit>
          {
            If(shouldShowAd && breakpoint !== 'mobile', () => (
              <Flex alignCenter justifyCenter className='AdSandwich__Ad AdSandwich__Ad--row'>
                {/* Mobile ads */}
                <AdContainer size={AdContainerSize.MOBILE_LEADERBOARD} className='--hideDesktop'>
                  <Yolla type={YollaType.MOBILE_LEADERBOARD} subType={YollaSubType.MOBILE_LEADERBOARD} num={2} />
                </AdContainer>
                {/* Desktop ads */}
                <AdContainer size={AdContainerSize.LEADERBOARD} className='--hideMobile'>
                  <Yolla type={YollaType.DESKTOP_LEADERBOARD} subType={YollaSubType.DESKTOP_LEADERBOARD} num={3} />
                </AdContainer>
              </Flex>
            )).EndIf()
          }
          <Flex 
            alignCenter 
            justifyCenter 
            fit 
            style={{ 
              position: 'relative',
              width: '100%',
              height: '100%',
            }}
          >
            {props.children}
          </Flex>
          {
            If(shouldShowAd, () => (
              <Flex alignCenter justifyCenter className='AdSandwich__Ad AdSandwich__Ad--row AdSandwich__Ad--bottomRow'>
                {/* Mobile ads */}
                <AdContainer size={AdContainerSize.MOBILE_LEADERBOARD} className='--hideDesktop'>
                  <Yolla type={YollaType.MOBILE_LEADERBOARD} subType={YollaSubType.MOBILE_LEADERBOARD} num={2} />
                </AdContainer>
                {/* Desktop ads */}
                <AdContainer size={AdContainerSize.LEADERBOARD} className='--hideMobile'>
                  <Yolla type={YollaType.DESKTOP_LEADERBOARD} subType={YollaSubType.DESKTOP_LEADERBOARD} num={4} />
                </AdContainer>
              </Flex>
            )).EndIf()
          }
        </Flex>
        {
          If(shouldShowAd, () => (
            <Flex alignCenter justifyCenter className='AdSandwich__Ad AdSandwich__Ad--column'>
              <Yolla type={YollaType.DESKTOP_MEDRECT} subType={YollaSubType.DESKTOP_HALFPAGE} num={2} />
            </Flex>
          )).EndIf()
        }
      </Flex>
    );
  }
);
